import api from "./api";

export const academicYearService = {
  getAll: () => api.get("/academic-years"),
  getActive: () => api.get("/academic-years/active"),
  create: (data) => api.post("/academic-years", data),
  setActive: (id) => api.put(`/academic-years/${id}/set-active`),
  carryForwardPreview: (id) =>
    api.get(`/academic-years/${id}/carry-forward-preview`),
  carryForward: (id, data) =>
    api.post(`/academic-years/${id}/carry-forward`, data),
  remove: (id) => api.delete(`/academic-years/${id}`),
};

export const financialYearService = {
  getAll: () => api.get("/financial-years"),
  getActive: () => api.get("/financial-years/active"),
  create: (data) => api.post("/financial-years", data),
  setActive: (id) => api.put(`/financial-years/${id}/set-active`),
  remove: (id) => api.delete(`/financial-years/${id}`),
};
